var map = {
	"./": 476,
	"./OldUi": 2647,
	"./OldUi.js": 2647,
	"./SpireonNew": 2648,
	"./SpireonNew.js": 2648,
	"./SpireonOld": 2649,
	"./SpireonOld.js": 2649,
	"./index": 476,
	"./index.js": 476,
	"./style": 365,
	"./style.js": 365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4138;